import { getCurrentUserId } from '../utils';
import { withCurrentParams } from 'actions/utils';
import { ENDPOINT_CREATE } from 'store/eventConstants';
import { BROADCAST_CREATE_STREAM_ENDPOINT } from 'actions/Types';

/**
 * Create a stream endpoint
 *
 * @param {*} endpoint
 */
export default endpoint => {
  return withCurrentParams(
    (dispatch, { teamId, eventId, broadcastId }, getState, socket) => {
      const { user } = getState();
      const action = {
        type: BROADCAST_CREATE_STREAM_ENDPOINT,
        request: async apiClient => {
          const resp = await apiClient.broadcast.createStreamEndpoint(
            teamId,
            eventId,
            broadcastId,
            endpoint
          );
          // notify other directors
          socket.emit(ENDPOINT_CREATE, {
            broadcastId,
            notifyingDirector: getCurrentUserId(user)
          });
          return resp;
        }
      };
      dispatch(action);
    }
  );
};
